"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookmlModelDto = void 0;
const lookmlModelNavExploreDto_1 = require("./lookmlModelNavExploreDto");
class LookmlModelDto {
    constructor(lookmlModelDto) {
        this.label = lookmlModelDto.label;
        this.name = lookmlModelDto.name;
        this.explores = lookmlModelDto?.explores?.map((explore) => new lookmlModelNavExploreDto_1.LookmlModelNavExploreDto(explore, lookmlModelDto.name));
    }
    static get QUERY_FIELDS() {
        return `label,name,explores(${lookmlModelNavExploreDto_1.LookmlModelNavExploreDto.QUERY_FIELDS})`;
    }
}
exports.LookmlModelDto = LookmlModelDto;
